<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot">“As we shall see, there is also considerable historical evidence of enormous networks of underground tunnels in both North, South and Central America, but it is not my intention to discuss the facts here, for that would preclude some of the conclusions I have reached concerning them, to which I shall come in later chapters.”</p>
<p class="epc">—Alec Maclellan, <span class="epub-i">The Lost World of Agharti</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?290f1e68